import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-recovery-dialog',
  templateUrl: './password-recovery-dialog.component.html',
  styleUrls: ['./password-recovery-dialog.component.scss'],
})
export class PasswordRecoveryDialogComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
